/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 11);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 1 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-theming");
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  // extracted by mini-css-extract-plugin
  module.exports = {
    "c-menu": "index__c-menu___4Vp4s",
    "is-open": "index__is-open___1o31H",
    "c-menu--down": "index__c-menu--down___1T3dw",
    "zd-menu--down-open": "index__zd-menu--down-open___1zb2N",
    "zd-menu--down-open-arrow": "index__zd-menu--down-open-arrow___1lssi",
    "c-menu--left": "index__c-menu--left___LrfG3",
    "zd-menu--left-open": "index__zd-menu--left-open___34J1h",
    "zd-menu--left-open-arrow": "index__zd-menu--left-open-arrow___MiyXP",
    "c-menu--right": "index__c-menu--right___1gHc7",
    "zd-menu--right-open": "index__zd-menu--right-open___1Wp4H",
    "zd-menu--right-open-arrow": "index__zd-menu--right-open-arrow___2thrS",
    "c-menu--up": "index__c-menu--up___HD-ee",
    "zd-menu--up-open": "index__zd-menu--up-open___3qIiH",
    "zd-menu--up-open-arrow": "index__zd-menu--up-open-arrow___1V5_a",
    "is-rtl": "index__is-rtl___1KUm_",
    "c-menu__item": "index__c-menu__item___1VmSc",
    "c-menu--sm": "index__c-menu--sm___4G5df",
    "c-menu__item--add": "index__c-menu__item--add___3ZqhT",
    "c-menu__item--header": "index__c-menu__item--header___2OHN9",
    "c-menu__item--previous": "index__c-menu__item--previous___3synr",
    "c-menu__item--header--icon": "index__c-menu__item--header--icon___HV2z4",
    "c-menu__item--header__icon": "index__c-menu__item--header__icon___2H0uX",
    "c-menu__item--next": "index__c-menu__item--next___1je1H",
    "is-checked": "index__is-checked___1Zp9_",
    "c-menu__item__meta": "index__c-menu__item__meta___2MCtT",
    "c-menu__item--media": "index__c-menu__item--media___2UFHl",
    "c-menu__item--media__figure": "index__c-menu__item--media__figure___1a6W9",
    "c-menu__item--media__body": "index__c-menu__item--media__body___2GZE7",
    "is-focused": "index__is-focused___g7yDa",
    "is-hovered": "index__is-hovered___3cIPG",
    "is-disabled": "index__is-disabled___2n_jm",
    "is-expanded": "index__is-expanded___2a5Ba",
    "is-hidden": "index__is-hidden___12Bww",
    "c-menu__separator": "index__c-menu__separator___2Bzvl"
  };
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  // extracted by mini-css-extract-plugin
  module.exports = {
    "c-txt": "text__c-txt___14ptu",
    "c-txt__input": "text__c-txt__input___2ZeOl",
    "is-rtl": "text__is-rtl___3wDRT",
    "c-txt__hint": "text__c-txt__hint___2Tn9V",
    "c-txt__label": "text__c-txt__label___11SEJ",
    "c-txt__message": "text__c-txt__message___J_8FM",
    "c-txt--inline": "text__c-txt--inline___1RdBX",
    "c-txt--sm__input": "text__c-txt--sm__input___32mOY",
    "c-txt__input--sm": "text__c-txt__input--sm___3aCeF",
    "c-txt__input--area": "text__c-txt__input--area___3VBq-",
    "is-resizable": "text__is-resizable___f1At_",
    "c-txt__input--select": "text__c-txt__input--select___7_VcN",
    "is-focused": "text__is-focused___3mc46",
    "is-disabled": "text__is-disabled___3Uekk",
    "is-hovered": "text__is-hovered___3bSTC",
    "is-open": "text__is-open___1jG9_",
    "c-txt__input--tag": "text__c-txt__input--tag___A2V01",
    "c-label": "text__c-label___3W5-I",
    "c-tag": "text__c-tag___251zu",
    "c-txt__input--focus-inset": "text__c-txt__input--focus-inset___2y9tx",
    "c-txt__input--error": "text__c-txt__input--error___15FsA",
    "c-txt__input--success": "text__c-txt__input--success___sCMHi",
    "c-txt__input--warning": "text__c-txt__input--warning___2X276",
    "c-txt__input--media__figure": "text__c-txt__input--media__figure___Qcs4_",
    "c-txt__input--bare": "text__c-txt__input--bare___2auEk",
    "c-txt__input--media": "text__c-txt__input--media___238Mn",
    "c-txt__input--media__body": "text__c-txt__input--media__body___5ImJI",
    "c-txt__label--regular": "text__c-txt__label--regular___3sfPL",
    "c-txt__label--sm": "text__c-txt__label--sm___1a2fm",
    "c-txt__message--error": "text__c-txt__message--error___1aGWx",
    "c-txt__message--success": "text__c-txt__message--success___U9a3o",
    "c-txt__message--warning": "text__c-txt__message--warning___6M0m2",
    "c-txt__hint--sm": "text__c-txt__hint--sm___3mH7Y"
  };
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = require("styled-components");
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("classnames");
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  // extracted by mini-css-extract-plugin
  module.exports = {
    "c-arrow": "index__c-arrow___cuUSh",
    "c-arrow--t": "index__c-arrow--t___1ZWKF",
    "c-arrow--tl": "index__c-arrow--tl___322NF",
    "c-arrow--tr": "index__c-arrow--tr___MeaCx",
    "c-arrow--r": "index__c-arrow--r___1QMUz",
    "c-arrow--rb": "index__c-arrow--rb___1HzLl",
    "c-arrow--rt": "index__c-arrow--rt___1e89v",
    "c-arrow--l": "index__c-arrow--l___1UW5e",
    "c-arrow--lb": "index__c-arrow--lb___1femU",
    "c-arrow--lt": "index__c-arrow--lt___uMq77",
    "c-arrow--b": "index__c-arrow--b___31z-F",
    "c-arrow--bl": "index__c-arrow--bl___Yjbqb",
    "c-arrow--br": "index__c-arrow--br___2cmY-"
  };
  /***/
},
/* 8 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/container-selection");
  /***/
},
/* 9 */

/***/
function (module, exports) {
  module.exports = require("react-popper");
  /***/
},
/* 10 */

/***/
function (module, exports) {
  module.exports = require("downshift");
  /***/
},
/* 11 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "prop-types"


  var external_prop_types_ = __webpack_require__(0);

  var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_); // EXTERNAL MODULE: external "classnames"


  var external_classnames_ = __webpack_require__(6);

  var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_); // EXTERNAL MODULE: external "styled-components"


  var external_styled_components_ = __webpack_require__(5);

  var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_); // EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-forms/dist/text.css


  var dist_text = __webpack_require__(4);

  var text_default = /*#__PURE__*/__webpack_require__.n(dist_text); // CONCATENATED MODULE: ./src/styled/field/StyledInput.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var hiddenStyling = Object(external_styled_components_["css"])(["position:absolute;left:-100px;transform:scale(0);opacity:0;outline:0;border-width:0;border-style:initial;border-color:initial;background:0 center;width:1px;color:transparent;font-size:inherit;"]);
  var StyledInput = external_styled_components_default.a.input.attrs({
    className: external_classnames_default()(text_default.a['c-txt__input'], text_default.a['c-txt__input--bare'])
  }).withConfig({
    displayName: "StyledInput",
    componentId: "at9c70-0"
  })(["&&{vertical-align:baseline;", "}"], function (props) {
    return props.isHidden && hiddenStyling;
  });
  StyledInput.propTypes = {
    isHidden: external_prop_types_default.a.bool
  };
  /* harmony default export */

  var field_StyledInput = StyledInput; // EXTERNAL MODULE: external "react"

  var external_react_ = __webpack_require__(1);

  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "@zendeskgarden/react-theming"


  var react_theming_ = __webpack_require__(2); // EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-menus/dist/index.css


  var dist = __webpack_require__(3);

  var dist_default = /*#__PURE__*/__webpack_require__.n(dist); // EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-arrows/dist/index.css


  var css_arrows_dist = __webpack_require__(7);

  var css_arrows_dist_default = /*#__PURE__*/__webpack_require__.n(css_arrows_dist); // CONCATENATED MODULE: ./src/styled/menu/StyledMenu.js


  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var COMPONENT_ID = 'dropdowns.menu';
  var PLACEMENT = {
    AUTO: 'auto',
    TOP: 'top',
    TOP_START: 'top-start',
    TOP_END: 'top-end',
    RIGHT: 'right',
    RIGHT_START: 'right-start',
    RIGHT_END: 'right-end',
    BOTTOM: 'bottom',
    BOTTOM_START: 'bottom-start',
    BOTTOM_END: 'bottom-end',
    LEFT: 'left',
    LEFT_START: 'left-start',
    LEFT_END: 'left-end'
  };

  var shouldShowArrow = function shouldShowArrow(_ref) {
    var arrow = _ref.arrow,
        placement = _ref.placement;
    return arrow && placement;
  };

  var retrieveMenuMargin = function retrieveMenuMargin(_ref2) {
    var arrow = _ref2.arrow,
        placement = _ref2.placement;
    var marginAmount = shouldShowArrow({
      arrow: arrow,
      placement: placement
    }) ? '8px' : '4px';

    if (placement === PLACEMENT.BOTTOM || placement === PLACEMENT.BOTTOM_START || placement === PLACEMENT.BOTTOM_END) {
      return "margin-top: ".concat(marginAmount, ";");
    }

    if (placement === PLACEMENT.TOP || placement === PLACEMENT.TOP_START || placement === PLACEMENT.TOP_END) {
      return "margin-bottom: ".concat(marginAmount, ";");
    }

    if (placement === PLACEMENT.LEFT || placement === PLACEMENT.LEFT_START || placement === PLACEMENT.LEFT_END) {
      return "margin-right: ".concat(marginAmount, ";");
    }

    if (placement === PLACEMENT.RIGHT || placement === PLACEMENT.RIGHT_START || placement === PLACEMENT.RIGHT_END) {
      return "margin-left: ".concat(marginAmount, ";");
    }

    return '';
  };
  /**
   * Accepts all `<ul>` props
   */


  var StyledMenuView = external_styled_components_default.a.ul.attrs({
    'data-garden-id': COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(dist_default.a['c-menu'], (_classNames = {}, _defineProperty(_classNames, dist_default.a['c-menu--sm'], props.small), _defineProperty(_classNames, dist_default.a['c-menu--up'], props.placement === PLACEMENT.TOP || props.placement === PLACEMENT.TOP_START || props.placement === PLACEMENT.TOP_END), _defineProperty(_classNames, dist_default.a['c-menu--right'], props.placement === PLACEMENT.RIGHT || props.placement === PLACEMENT.RIGHT_START || props.placement === PLACEMENT.RIGHT_END), _defineProperty(_classNames, dist_default.a['c-menu--left'], props.placement === PLACEMENT.LEFT || props.placement === PLACEMENT.LEFT_START || props.placement === PLACEMENT.LEFT_END), _defineProperty(_classNames, dist_default.a['c-menu--down'], props.placement === PLACEMENT.BOTTOM || props.placement === PLACEMENT.BOTTOM_START || props.placement === PLACEMENT.BOTTOM_END), _defineProperty(_classNames, dist_default.a['is-open'], props.animate), _defineProperty(_classNames, dist_default.a['is-hidden'], props.hidden), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow'], shouldShowArrow(props)), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--r'], props.placement === PLACEMENT.LEFT), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--rt'], props.placement === PLACEMENT.LEFT_START), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--rb'], props.placement === PLACEMENT.LEFT_END), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--b'], props.placement === PLACEMENT.TOP), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--bl'], props.placement === PLACEMENT.TOP_START), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--br'], props.placement === PLACEMENT.TOP_END), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--l'], props.placement === PLACEMENT.RIGHT), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--lt'], props.placement === PLACEMENT.RIGHT_START), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--lb'], props.placement === PLACEMENT.RIGHT_END), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--t'], props.placement === PLACEMENT.BOTTOM), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--tl'], props.placement === PLACEMENT.BOTTOM_START), _defineProperty(_classNames, css_arrows_dist_default.a['c-arrow--tr'], props.placement === PLACEMENT.BOTTOM_END), _defineProperty(_classNames, dist_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "StyledMenu__StyledMenuView",
    componentId: "sc-1e01vo5-0"
  })(["&&{position:relative;}:focus{outline:none;}", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(COMPONENT_ID, props);
  });
  var StyledMenuWrapper = external_styled_components_default.a.div.withConfig({
    displayName: "StyledMenu__StyledMenuWrapper",
    componentId: "sc-1e01vo5-1"
  })(["", ";"], retrieveMenuMargin);
  var StyledMaxHeightWrapper = external_styled_components_default.a.div.withConfig({
    displayName: "StyledMenu__StyledMaxHeightWrapper",
    componentId: "sc-1e01vo5-2"
  })(["", ""], function (props) {
    return props.maxHeight && !props.height && "\n  overflow-y: auto;\n  max-height: ".concat(props.maxHeight, ";\n");
  });
  var StyledMenu = external_react_default.a.forwardRef(function (_ref3, ref) {
    var arrow = _ref3.arrow,
        placement = _ref3.placement,
        maxHeight = _ref3.maxHeight,
        children = _ref3.children,
        other = _objectWithoutProperties(_ref3, ["arrow", "placement", "maxHeight", "children"]);

    return external_react_default.a.createElement(StyledMenuWrapper, {
      arrow: arrow,
      placement: placement
    }, external_react_default.a.createElement(StyledMenuView, _extends({
      innerRef: ref,
      arrow: arrow,
      placement: placement
    }, other), external_react_default.a.createElement(StyledMaxHeightWrapper, {
      maxHeight: maxHeight
    }, children)));
  });
  StyledMenu.propTypes = {
    /**
     * All valid [Popper.JS Placements](https://popper.js.org/popper-documentation.html#Popper.placements)
     */
    placement: external_prop_types_default.a.oneOf([PLACEMENT.AUTO, PLACEMENT.TOP, PLACEMENT.TOP_START, PLACEMENT.TOP_END, PLACEMENT.RIGHT, PLACEMENT.RIGHT_START, PLACEMENT.RIGHT_END, PLACEMENT.BOTTOM, PLACEMENT.BOTTOM_START, PLACEMENT.BOTTOM_END, PLACEMENT.LEFT, PLACEMENT.LEFT_START, PLACEMENT.LEFT_END]),
    animate: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool,
    hidden: external_prop_types_default.a.bool,
    arrow: external_prop_types_default.a.bool,
    maxHeight: external_prop_types_default.a.string,
    children: external_prop_types_default.a.node
  };
  /** @component */

  /* harmony default export */

  var menu_StyledMenu = StyledMenu; // CONCATENATED MODULE: ./src/styled/menu/StyledSeparator.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledSeparator_COMPONENT_ID = 'dropdowns.separator';
  /**
   * Accepts all `<li>` props
   */

  var StyledSeparator = external_styled_components_default.a.li.attrs({
    'data-garden-id': StyledSeparator_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    role: 'separator',
    className: dist_default.a['c-menu__separator']
  }).withConfig({
    displayName: "StyledSeparator",
    componentId: "t4wpc5-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledSeparator_COMPONENT_ID, props);
  });
  /** @component */

  /* harmony default export */

  var menu_StyledSeparator = StyledSeparator; // CONCATENATED MODULE: ./src/styled/items/StyledItem.js

  function StyledItem_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var StyledItem_COMPONENT_ID = 'dropdowns.item';
  /**
   * Accepts all `<li>` props
   */

  var StyledItem = external_styled_components_default.a.li.attrs({
    'data-garden-id': StyledItem_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(dist_default.a['c-menu__item'], (_classNames = {}, StyledItem_defineProperty(_classNames, dist_default.a['is-active'], props.active), StyledItem_defineProperty(_classNames, dist_default.a['is-focused'], props.focused), StyledItem_defineProperty(_classNames, dist_default.a['is-hovered'], props.hovered), StyledItem_defineProperty(_classNames, dist_default.a['is-disabled'], props.disabled), StyledItem_defineProperty(_classNames, dist_default.a['is-checked'], props.checked), _classNames));
    }
  }).withConfig({
    displayName: "StyledItem",
    componentId: "sc-13s21of-0"
  })(["", ";", ";"], function (props) {
    return !props.focused && "&&&:hover {\n      background-color: inherit;\n    }\n  ";
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledItem_COMPONENT_ID, props);
  });
  StyledItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var items_StyledItem = StyledItem; // CONCATENATED MODULE: ./src/styled/items/StyledAddItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledAddItem_COMPONENT_ID = 'dropdowns.add_item';
  /**
   * Accepts all `<li>` props
   */

  var StyledAddItem = external_styled_components_default()(items_StyledItem).attrs({
    'data-garden-id': StyledAddItem_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: dist_default.a['c-menu__item--add']
  }).withConfig({
    displayName: "StyledAddItem",
    componentId: "aw2048-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledAddItem_COMPONENT_ID, props);
  });
  StyledAddItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var items_StyledAddItem = StyledAddItem; // CONCATENATED MODULE: ./src/styled/items/StyledItemMeta.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledItemMeta_COMPONENT_ID = 'dropdowns.item_meta';
  /**
   * Accepts all `<span>` props
   */

  var StyledItemMeta = external_styled_components_default.a.span.attrs({
    'data-garden-id': StyledItemMeta_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: dist_default.a['c-menu__item__meta']
  }).withConfig({
    displayName: "StyledItemMeta",
    componentId: "y6klcr-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledItemMeta_COMPONENT_ID, props);
  });
  /** @component */

  /* harmony default export */

  var items_StyledItemMeta = StyledItemMeta; // CONCATENATED MODULE: ./src/styled/items/StyledNextItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledNextItem_COMPONENT_ID = 'dropdowns.next_item';
  /**
   * Accepts all `<li>` props
   */

  var StyledNextItem = external_styled_components_default()(items_StyledItem).attrs({
    'data-garden-id': StyledNextItem_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: dist_default.a['c-menu__item--next']
  }).withConfig({
    displayName: "StyledNextItem",
    componentId: "sc-8cecku-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledNextItem_COMPONENT_ID, props);
  });
  StyledNextItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var items_StyledNextItem = StyledNextItem; // CONCATENATED MODULE: ./src/styled/items/StyledPreviousItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledPreviousItem_COMPONENT_ID = 'dropdowns.previous_item';
  /**
   * Accepts all `<li>` props
   */

  var StyledPreviousItem = external_styled_components_default()(items_StyledItem).attrs({
    'data-garden-id': StyledPreviousItem_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: dist_default.a['c-menu__item--previous']
  }).withConfig({
    displayName: "StyledPreviousItem",
    componentId: "sc-1hv5rty-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledPreviousItem_COMPONENT_ID, props);
  });
  StyledPreviousItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var items_StyledPreviousItem = StyledPreviousItem; // CONCATENATED MODULE: ./src/styled/items/header/StyledHeaderIcon.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledHeaderIcon_COMPONENT_ID = 'dropdowns.header_icon';

  var StyledHeaderIcon_StyledHeaderIcon = function StyledHeaderIcon(_ref) {
    var children = _ref.children;
    return external_react_default.a.cloneElement(external_react_["Children"].only(children), {
      'data-garden-id': StyledHeaderIcon_COMPONENT_ID,
      'data-garden-version': "0.2.2",
      className: dist_default.a['c-menu__item--header__icon']
    });
  };
  /** @component */

  /* harmony default export */


  var header_StyledHeaderIcon = StyledHeaderIcon_StyledHeaderIcon; // CONCATENATED MODULE: ./src/styled/items/header/StyledHeaderItem.js

  function StyledHeaderItem_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var StyledHeaderItem_COMPONENT_ID = 'dropdowns.header_item';
  /**
   * Accepts all `<li>` props
   */

  var StyledHeaderItem = external_styled_components_default()(items_StyledItem).attrs({
    'data-garden-id': StyledHeaderItem_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: function className(props) {
      return external_classnames_default()(dist_default.a['c-menu__item--header'], StyledHeaderItem_defineProperty({}, dist_default.a['c-menu__item--header--icon'], props.containsIcon));
    }
  }).withConfig({
    displayName: "StyledHeaderItem",
    componentId: "sc-5won5o-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledHeaderItem_COMPONENT_ID, props);
  });
  StyledHeaderItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool,

    /** Applies icon styling */
    containsIcon: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var header_StyledHeaderItem = StyledHeaderItem; // CONCATENATED MODULE: ./src/styled/items/media/StyledMediaBody.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledMediaBody_COMPONENT_ID = 'dropdowns.media_body';
  /**
   * Accepts all `<div>` props
   */

  var StyledMediaBody = external_styled_components_default.a.div.attrs({
    'data-garden-id': StyledMediaBody_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: dist_default.a['c-menu__item--media__body']
  }).withConfig({
    displayName: "StyledMediaBody",
    componentId: "sc-1v1l8oe-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledMediaBody_COMPONENT_ID, props);
  });
  /** @component */

  /* harmony default export */

  var media_StyledMediaBody = StyledMediaBody; // CONCATENATED MODULE: ./src/styled/items/media/StyledMediaFigure.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledMediaFigure_COMPONENT_ID = 'dropdowns.media_figure';

  var StyledMediaFigure_StyledMediaFigure = function StyledMediaFigure(_ref) {
    var children = _ref.children;
    return external_react_default.a.cloneElement(external_react_["Children"].only(children), {
      'data-garden-id': StyledMediaFigure_COMPONENT_ID,
      'data-garden-version': "0.2.2",
      className: dist_default.a['c-menu__item--media__figure']
    });
  };
  /** @component */

  /* harmony default export */


  var media_StyledMediaFigure = StyledMediaFigure_StyledMediaFigure; // CONCATENATED MODULE: ./src/styled/items/media/StyledMediaItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var StyledMediaItem_COMPONENT_ID = 'dropdowns.media_item';
  /**
   * Accepts all `<li>` props
   */

  var StyledMediaItem = external_styled_components_default()(items_StyledItem).attrs({
    'data-garden-id': StyledMediaItem_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: dist_default.a['c-menu__item--media']
  }).withConfig({
    displayName: "StyledMediaItem",
    componentId: "sc-1af904c-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledMediaItem_COMPONENT_ID, props);
  });
  StyledMediaItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var media_StyledMediaItem = StyledMediaItem; // CONCATENATED MODULE: ./src/styled/field/StyledField.js

  function StyledField_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var StyledField_COMPONENT_ID = 'dropdowns.text_group';
  /**
   * Accepts all `<div>` props
   */

  var StyledField = external_styled_components_default.a.div.attrs({
    'data-garden-id': StyledField_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt'], (_classNames = {}, StyledField_defineProperty(_classNames, text_default.a['c-txt--inline'], props.inline), StyledField_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "StyledField",
    componentId: "sc-1aovr8p-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledField_COMPONENT_ID, props);
  });
  StyledField.propTypes = {
    inline: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var field_StyledField = StyledField; // CONCATENATED MODULE: ./src/styled/field/StyledLabel.js

  function StyledLabel_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var StyledLabel_COMPONENT_ID = 'dropdown.label';
  /**
   * Accepts all `<label>` props
   */

  var StyledLabel = external_styled_components_default.a.label.attrs({
    'data-garden-id': StyledLabel_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__label'], (_classNames = {}, StyledLabel_defineProperty(_classNames, text_default.a['c-txt__label--regular'], props.regular), StyledLabel_defineProperty(_classNames, text_default.a['c-txt__label--sm'], props.small), StyledLabel_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "StyledLabel",
    componentId: "sc-2j0god-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledLabel_COMPONENT_ID, props);
  });
  StyledLabel.propTypes = {
    regular: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var field_StyledLabel = StyledLabel; // CONCATENATED MODULE: ./src/styled/field/StyledHint.js

  function StyledHint_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var StyledHint_COMPONENT_ID = 'dropdowns.hint';
  /**
   * Accepts all `<div>` props
   */

  var StyledHint = external_styled_components_default.a.div.attrs({
    'data-garden-id': StyledHint_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__hint'], (_classNames = {}, StyledHint_defineProperty(_classNames, text_default.a['c-txt__hint--sm'], props.small), StyledHint_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "StyledHint",
    componentId: "vgkd1c-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledHint_COMPONENT_ID, props);
  });
  StyledHint.propTypes = {
    small: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var field_StyledHint = StyledHint; // CONCATENATED MODULE: ./src/styled/field/StyledMessage.js

  function StyledMessage_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var StyledMessage_COMPONENT_ID = 'dropdowns.message';
  var VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    NONE: 'none'
  };
  /**
   * Accepts all `<div>` props
   */

  var StyledMessage = external_styled_components_default.a.div.attrs({
    'data-garden-id': StyledMessage_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    role: 'alert',
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__message'], (_classNames = {}, StyledMessage_defineProperty(_classNames, text_default.a['c-txt__message--success'], props.validation === VALIDATION.SUCCESS), StyledMessage_defineProperty(_classNames, text_default.a['c-txt__message--warning'], props.validation === VALIDATION.WARNING), StyledMessage_defineProperty(_classNames, text_default.a['c-txt__message--error'], props.validation === VALIDATION.ERROR), StyledMessage_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "StyledMessage",
    componentId: "sc-1nnoyc-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledMessage_COMPONENT_ID, props);
  });
  StyledMessage.propTypes = {
    validation: external_prop_types_default.a.oneOf([VALIDATION.SUCCESS, VALIDATION.WARNING, VALIDATION.ERROR, VALIDATION.NONE])
  };
  /** @component */

  /* harmony default export */

  var field_StyledMessage = StyledMessage; // CONCATENATED MODULE: ./src/styled/field/StyledSelect.js

  function StyledSelect_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var StyledSelect_COMPONENT_ID = 'dropdowns.select_view';
  var StyledSelect_VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
  };

  var isInvalid = function isInvalid(validation) {
    return validation === StyledSelect_VALIDATION.WARNING || validation === StyledSelect_VALIDATION.ERROR;
  };

  var StyledSelect = external_styled_components_default.a.div.attrs({
    'data-garden-id': StyledSelect_COMPONENT_ID,
    'data-garden-version': "0.2.2",
    'aria-invalid': function ariaInvalid(props) {
      return isInvalid(props.validation);
    },
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(text_default.a['c-txt__input'], text_default.a['c-txt__input--select'], (_classNames = {}, StyledSelect_defineProperty(_classNames, text_default.a['c-txt__input--sm'], props.small), StyledSelect_defineProperty(_classNames, text_default.a['c-txt__input--tag'], props.tagLayout), StyledSelect_defineProperty(_classNames, text_default.a['c-txt__input--media'], props.mediaLayout), StyledSelect_defineProperty(_classNames, text_default.a['c-txt__input--bare'], props.bare), StyledSelect_defineProperty(_classNames, text_default.a['c-txt__input--focus-inset'], props.focusInset), StyledSelect_defineProperty(_classNames, text_default.a['is-disabled'], props.disabled), StyledSelect_defineProperty(_classNames, text_default.a['is-focused'], props.focused), StyledSelect_defineProperty(_classNames, text_default.a['is-hovered'], props.hovered), StyledSelect_defineProperty(_classNames, text_default.a['is-open'], props.open), StyledSelect_defineProperty(_classNames, text_default.a['c-txt__input--success'], props.validation === StyledSelect_VALIDATION.SUCCESS), StyledSelect_defineProperty(_classNames, text_default.a['c-txt__input--warning'], props.validation === StyledSelect_VALIDATION.WARNING), StyledSelect_defineProperty(_classNames, text_default.a['c-txt__input--error'], props.validation === StyledSelect_VALIDATION.ERROR), StyledSelect_defineProperty(_classNames, text_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "StyledSelect",
    componentId: "sc-1cx9af-0"
  })(["cursor:default;", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])(StyledSelect_COMPONENT_ID, props);
  });
  StyledSelect.propTypes = {
    /** Allows flush spacing of Tab elements */
    tagLayout: external_prop_types_default.a.bool,

    /** Applies flex layout to support MediaFigure components */
    mediaLayout: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool,

    /** Removes all borders and styling */
    bare: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,

    /** Applies inset `box-shadow` styling on focus */
    focusInset: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,

    /** Displays select open state */
    open: external_prop_types_default.a.bool,
    validation: external_prop_types_default.a.oneOf([StyledSelect_VALIDATION.SUCCESS, StyledSelect_VALIDATION.WARNING, StyledSelect_VALIDATION.ERROR])
  };
  /** @component */

  /* harmony default export */

  var field_StyledSelect = StyledSelect; // CONCATENATED MODULE: ./src/styled/index.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */
  // EXTERNAL MODULE: external "downshift"

  var external_downshift_ = __webpack_require__(10);

  var external_downshift_default = /*#__PURE__*/__webpack_require__.n(external_downshift_); // EXTERNAL MODULE: external "react-popper"


  var external_react_popper_ = __webpack_require__(9); // EXTERNAL MODULE: external "@zendeskgarden/container-selection"


  var container_selection_ = __webpack_require__(8); // CONCATENATED MODULE: ./src/Dropdown/Dropdown.js


  function Dropdown_extends() {
    Dropdown_extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return Dropdown_extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Dropdown_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Dropdown_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function Dropdown_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Dropdown_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Dropdown_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var DropdownContext = external_react_default.a.createContext();
  /**
   * Component that provides state and a11y through the context API
   * to its consumers.
   */

  function Dropdown(props) {
    var children = props.children,
        isOpen = props.isOpen,
        selectedItem = props.selectedItem,
        selectedItems = props.selectedItems,
        highlightedIndex = props.highlightedIndex,
        inputValue = props.inputValue,
        onSelect = props.onSelect,
        _onStateChange = props.onStateChange,
        downshiftProps = props.downshiftProps; // Refs used to handle custom Garden keyboard nav

    var itemIndexRef = Object(external_react_["useRef"])(0);
    var previousItemRef = Object(external_react_["useRef"])(undefined);
    var previousIndexRef = Object(external_react_["useRef"])(undefined);
    var nextItemsHashRef = Object(external_react_["useRef"])({}); // Used to inform Menu (Popper) that a full-width menu is needed

    var popperReferenceElementRef = Object(external_react_["useRef"])(null);
    /**
     * Add additional keyboard nav to the basics provided by Downshift
     **/

    var customGetInputProps = function customGetInputProps(_ref, downshift, rtl) {
      var onKeyDown = _ref.onKeyDown,
          other = Dropdown_objectWithoutProperties(_ref, ["onKeyDown"]);
      return _objectSpread({
        onKeyDown: Object(container_selection_["composeEventHandlers"])(onKeyDown, function (e) {
          var PREVIOUS_KEY = rtl ? container_selection_["KEY_CODES"].RIGHT : container_selection_["KEY_CODES"].LEFT;
          var NEXT_KEY = rtl ? container_selection_["KEY_CODES"].LEFT : container_selection_["KEY_CODES"].RIGHT;

          if (downshift.isOpen) {
            // Select highlighted item on TAB
            if (e.keyCode === container_selection_["KEY_CODES"].TAB) {
              e.preventDefault();
              e.stopPropagation();
              downshift.selectHighlightedItem();
            } // Select previous item if available


            if (e.keyCode === PREVIOUS_KEY && previousIndexRef.current !== null && !downshift.inputValue) {
              e.preventDefault();
              e.stopPropagation();
              downshift.selectItemAtIndex(previousIndexRef.current);
            } // Select current next item if available


            if (e.keyCode === NEXT_KEY) {
              var nextItemIndexes = Object.values(nextItemsHashRef.current);

              if (nextItemIndexes.includes(downshift.highlightedIndex)) {
                e.preventDefault();
                e.stopPropagation();
                downshift.selectItemAtIndex(downshift.highlightedIndex);
              }
            }
          } else if ((e.keyCode === container_selection_["KEY_CODES"].ENTER || e.keyCode === container_selection_["KEY_CODES"].SPACE) && !downshift.isOpen) {
            e.preventDefault();
            e.stopPropagation();
            downshift.openMenu();
          }
        })
      }, other);
    };

    var transformDownshift = function transformDownshift(_ref2) {
      var _getInputProps = _ref2.getInputProps,
          _getToggleButtonProps = _ref2.getToggleButtonProps,
          downshift = Dropdown_objectWithoutProperties(_ref2, ["getInputProps", "getToggleButtonProps"]);
      return _objectSpread({
        getInputProps: function getInputProps(p) {
          return _getInputProps(customGetInputProps(p, downshift, Object(react_theming_["isRtl"])(props)));
        },
        // The default aria-label provided by Downshift is invalid due to our DOM structure
        getToggleButtonProps: function getToggleButtonProps(p) {
          return _getToggleButtonProps(_objectSpread({
            'aria-label': undefined
          }, p));
        }
      }, downshift);
    };

    return external_react_default.a.createElement(external_react_popper_["Manager"], null, external_react_default.a.createElement(external_downshift_default.a, Dropdown_extends({
      suppressRefError: true // https://github.com/downshift-js/downshift/issues/529 Allows us to provide props through context
      ,
      isOpen: isOpen,
      highlightedIndex: highlightedIndex,
      selectedItem: selectedItem || null // Ensures that selectedItem never becomes controlled internally by Downshift
      ,
      inputValue: inputValue,
      onStateChange: function onStateChange(changes, stateAndHelpers) {
        if (Object.prototype.hasOwnProperty.call(changes, 'selectedItem') && changes.selectedItem !== null) {
          if (selectedItems) {
            var itemToString = stateAndHelpers.itemToString;
            var existingItemIndex = selectedItems.findIndex(function (item) {
              return itemToString(item) === itemToString(changes.selectedItem);
            });
            var updatedSelectedItems = Array.from(selectedItems);

            if (existingItemIndex === -1) {
              updatedSelectedItems.splice(updatedSelectedItems.length, 0, changes.selectedItem);
            } else {
              updatedSelectedItems.splice(existingItemIndex, 1);
            }
            /**
             * Customize the changes returned from `onStateChange` as
             * Downshift has no concept of a "multiselect".
             **/


            changes.selectedItems = updatedSelectedItems;
            delete changes.selectedItem;
            onSelect && onSelect(updatedSelectedItems, stateAndHelpers);
          } else {
            onSelect && onSelect(changes.selectedItem, stateAndHelpers);
          }
        }

        _onStateChange && _onStateChange(changes, stateAndHelpers);
      },
      stateReducer: function stateReducer(_state, changes) {
        /**
         * Set inputValue to an empty string during any event that updates the inputValue
         */
        switch (changes.type) {
          case external_downshift_default.a.stateChangeTypes.controlledPropUpdatedSelectedItem:
          case external_downshift_default.a.stateChangeTypes.mouseUp:
          case external_downshift_default.a.stateChangeTypes.keyDownEnter:
          case external_downshift_default.a.stateChangeTypes.clickItem:
          case external_downshift_default.a.stateChangeTypes.clickButton:
          case external_downshift_default.a.stateChangeTypes.keyDownSpaceButton:
          case external_downshift_default.a.stateChangeTypes.blurButton:
            return _objectSpread({}, changes, {
              inputValue: ''
            });

          default:
            return changes;
        }
      }
    }, downshiftProps), function (downshift) {
      return external_react_default.a.createElement(DropdownContext.Provider, {
        value: {
          itemIndexRef: itemIndexRef,
          previousItemRef: previousItemRef,
          previousIndexRef: previousIndexRef,
          nextItemsHashRef: nextItemsHashRef,
          popperReferenceElementRef: popperReferenceElementRef,
          selectedItems: selectedItems,
          downshift: transformDownshift(downshift)
        }
      }, children);
    }));
  }

  Dropdown.propTypes = {
    children: external_prop_types_default.a.node,
    isOpen: external_prop_types_default.a.bool,
    selectedItem: external_prop_types_default.a.any,
    selectedItems: external_prop_types_default.a.arrayOf(external_prop_types_default.a.any),
    highlightedIndex: external_prop_types_default.a.number,
    inputValue: external_prop_types_default.a.string,
    onSelect: external_prop_types_default.a.func,
    onStateChange: external_prop_types_default.a.func,
    downshiftProps: external_prop_types_default.a.object
  };
  /* harmony default export */

  var Dropdown_Dropdown = Object(react_theming_["withTheme"])(Dropdown); // CONCATENATED MODULE: ./src/utils/useDropdownContext.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Retrieve Dropdown component context
   */

  var useDropdownContext_useDropdownContext = function useDropdownContext() {
    var dropdownContext = Object(external_react_["useContext"])(DropdownContext);

    if (!dropdownContext) {
      throw new Error('This component must be rendered within a `Dropdown` component.');
    }

    return dropdownContext;
  };
  /* harmony default export */


  var utils_useDropdownContext = useDropdownContext_useDropdownContext; // CONCATENATED MODULE: ./src/Trigger/Trigger.js

  function Trigger_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Trigger_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Trigger_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function Trigger_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Trigger_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Trigger_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Applies state and a11y attributes to its children. Must be nested within a `<Dropdown>` component.
   */


  var Trigger_Trigger = function Trigger(_ref) {
    var children = _ref.children,
        refKey = _ref.refKey,
        triggerProps = Trigger_objectWithoutProperties(_ref, ["children", "refKey"]);

    var _useDropdownContext = utils_useDropdownContext(),
        _useDropdownContext$d = _useDropdownContext.downshift,
        getRootProps = _useDropdownContext$d.getRootProps,
        getToggleButtonProps = _useDropdownContext$d.getToggleButtonProps,
        getInputProps = _useDropdownContext$d.getInputProps,
        isOpen = _useDropdownContext$d.isOpen;

    var hiddenInputRef = Object(external_react_["useRef"])(null);
    var triggerRef = Object(external_react_["useRef"])(null);
    var previousIsOpenRef = Object(external_react_["useRef"])(undefined);
    Object(external_react_["useEffect"])(function () {
      // Focus internal input when Menu is opened
      if (isOpen && !previousIsOpenRef.current) {
        hiddenInputRef.current && hiddenInputRef.current.focus();
      } // Focus trigger when Menu is closed


      if (!isOpen && previousIsOpenRef.current) {
        triggerRef.current && triggerRef.current.focus();
      }

      previousIsOpenRef.current = isOpen;
    }, [isOpen]);

    var renderChildren = function renderChildren(popperRef) {
      // Destructuring the `ref` argument lets us share it with PopperJS
      var _getRootProps = getRootProps(),
          rootPropsRefCallback = _getRootProps.ref,
          rootProps = Trigger_objectWithoutProperties(_getRootProps, ["ref"]);
      /**
       * Clone immediate child and provide:
       * - Necessary downshift props
       * - Ref collector based on `refKey` prop
       */


      return external_react_default.a.cloneElement(external_react_default.a.Children.only(children), Trigger_objectSpread({}, getToggleButtonProps(Trigger_objectSpread({}, rootProps, triggerProps, children.props)), Trigger_defineProperty({}, refKey, function (childRef) {
        // Pass ref to popperJS for positioning
        popperRef(childRef); // Store ref locally to return focus on close

        triggerRef.current = childRef; // Pass ref to getRootProps()

        rootPropsRefCallback(childRef);
      })));
    };

    return external_react_default.a.createElement(external_react_popper_["Reference"], null, function (_ref2) {
      var popperReference = _ref2.ref;
      return external_react_default.a.createElement(external_react_default.a.Fragment, null, renderChildren(popperReference), external_react_default.a.createElement(field_StyledInput, getInputProps({
        readOnly: true,
        isHidden: true,
        tabIndex: -1,
        innerRef: hiddenInputRef,
        value: ''
      })));
    });
  };

  Trigger_Trigger.propTypes = {
    children: external_prop_types_default.a.any,
    refKey: external_prop_types_default.a.string
  };
  Trigger_Trigger.defaultProps = {
    refKey: 'ref'
  };
  /* harmony default export */

  var src_Trigger_Trigger = Trigger_Trigger; // CONCATENATED MODULE: ./src/Fields/Field.js

  function Field_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Field_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Field_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var FieldContext = Object(external_react_["createContext"])(undefined);
  /**
   * Accepts all `<div>` props
   */

  function Field(props) {
    var _useDropdownContext = utils_useDropdownContext(),
        getRootProps = _useDropdownContext.downshift.getRootProps;

    var _useState = Object(external_react_["useState"])(false),
        _useState2 = _slicedToArray(_useState, 2),
        isLabelHovered = _useState2[0],
        setIsLabelHovered = _useState2[1];

    return external_react_default.a.createElement(FieldContext.Provider, {
      value: {
        isLabelHovered: isLabelHovered,
        setIsLabelHovered: setIsLabelHovered
      }
    }, external_react_default.a.createElement(field_StyledField, getRootProps(Field_objectSpread({
      refKey: 'innerRef'
    }, props))));
  }

  Field.propTypes = {
    inline: external_prop_types_default.a.bool
  };
  /* harmony default export */

  var Fields_Field = Field; // CONCATENATED MODULE: ./src/utils/useFieldContext.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Retrieve Field component context
   */

  var useFieldContext_useFieldContext = function useFieldContext() {
    var fieldContext = Object(external_react_["useContext"])(FieldContext);

    if (!fieldContext) {
      throw new Error('This component must be rendered within a `Field` component.');
    }

    return fieldContext;
  };
  /* harmony default export */


  var utils_useFieldContext = useFieldContext_useFieldContext; // CONCATENATED MODULE: ./src/Autocomplete/Autocomplete.js

  function Autocomplete_extends() {
    Autocomplete_extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return Autocomplete_extends.apply(this, arguments);
  }

  function Autocomplete_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Autocomplete_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Autocomplete_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function Autocomplete_slicedToArray(arr, i) {
    return Autocomplete_arrayWithHoles(arr) || Autocomplete_iterableToArrayLimit(arr, i) || Autocomplete_nonIterableRest();
  }

  function Autocomplete_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function Autocomplete_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function Autocomplete_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function Autocomplete_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Autocomplete_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Autocomplete_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Autocomplete_VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
  };
  /**
   * Applies state and a11y attributes to its children. Must be nested within a `<Field>` component.
   */

  var Autocomplete_Autocomplete = function Autocomplete(_ref) {
    var children = _ref.children,
        props = Autocomplete_objectWithoutProperties(_ref, ["children"]);

    var _useDropdownContext = utils_useDropdownContext(),
        popperReferenceElementRef = _useDropdownContext.popperReferenceElementRef,
        _useDropdownContext$d = _useDropdownContext.downshift,
        getToggleButtonProps = _useDropdownContext$d.getToggleButtonProps,
        getInputProps = _useDropdownContext$d.getInputProps,
        isOpen = _useDropdownContext$d.isOpen;

    var _useFieldContext = utils_useFieldContext(),
        isLabelHovered = _useFieldContext.isLabelHovered;

    var inputRef = Object(external_react_["useRef"])(null);
    var triggerRef = Object(external_react_["useRef"])(null);
    var previousIsOpenRef = Object(external_react_["useRef"])(undefined);

    var _useState = Object(external_react_["useState"])(false),
        _useState2 = Autocomplete_slicedToArray(_useState, 2),
        isFocused = _useState2[0],
        setIsFocused = _useState2[1];

    Object(external_react_["useEffect"])(function () {
      // Focus internal input when Menu is opened
      if (isOpen && !previousIsOpenRef.current) {
        inputRef.current && inputRef.current.focus();
      } // Focus trigger when Menu is closed


      if (!isOpen && previousIsOpenRef.current) {
        triggerRef.current && triggerRef.current.focus();
      }

      previousIsOpenRef.current = isOpen;
    }, [isOpen]);
    var selectProps = getToggleButtonProps(Autocomplete_objectSpread({
      onKeyDown: function onKeyDown(e) {
        if (isOpen) {
          e.nativeEvent.preventDownshiftDefault = true;
        }
      }
    }, props));
    return external_react_default.a.createElement(external_react_popper_["Reference"], null, function (_ref2) {
      var popperReference = _ref2.ref;
      return external_react_default.a.createElement(field_StyledSelect, Autocomplete_extends({
        hovered: isLabelHovered && !isOpen,
        focused: isOpen ? true : isFocused,
        open: isOpen,
        innerRef: function innerRef(selectRef) {
          // Pass ref to popperJS for positioning
          popperReference(selectRef); // Store ref locally to return focus on close

          triggerRef.current = selectRef; // Apply Select ref to global Dropdown context

          popperReferenceElementRef.current = selectRef;
        }
      }, selectProps), !isOpen && children, external_react_default.a.createElement(field_StyledInput, getInputProps({
        isHidden: !isOpen,
        disabled: props.disabled,
        onFocus: function onFocus() {
          setIsFocused(true);
        },
        onBlur: function onBlur() {
          setIsFocused(false);
        },
        innerRef: inputRef
      })));
    });
  };

  Autocomplete_Autocomplete.propTypes = {
    children: external_prop_types_default.a.node,

    /** Allows flush spacing of Tab elements */
    tagLayout: external_prop_types_default.a.bool,

    /** Applies flex layout to support MediaFigure components */
    mediaLayout: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool,

    /** Removes all borders and styling */
    bare: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,

    /** Applies inset `box-shadow` styling on focus */
    focusInset: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,

    /** Displays select open state */
    open: external_prop_types_default.a.bool,
    validation: external_prop_types_default.a.oneOf([Autocomplete_VALIDATION.SUCCESS, Autocomplete_VALIDATION.WARNING, Autocomplete_VALIDATION.ERROR])
  };
  /* harmony default export */

  var src_Autocomplete_Autocomplete = Autocomplete_Autocomplete; // CONCATENATED MODULE: ./src/Select/Select.js

  function Select_extends() {
    Select_extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return Select_extends.apply(this, arguments);
  }

  function Select_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Select_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Select_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function Select_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Select_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Select_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Select_VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
  };
  /**
   * Applies state and a11y attributes to its children. Must be nested within a `<Field>` component.
   */

  var Select_Select = function Select(_ref) {
    var children = _ref.children,
        props = Select_objectWithoutProperties(_ref, ["children"]);

    var _useDropdownContext = utils_useDropdownContext(),
        popperReferenceElementRef = _useDropdownContext.popperReferenceElementRef,
        _useDropdownContext$d = _useDropdownContext.downshift,
        getToggleButtonProps = _useDropdownContext$d.getToggleButtonProps,
        getInputProps = _useDropdownContext$d.getInputProps,
        isOpen = _useDropdownContext$d.isOpen;

    var _useFieldContext = utils_useFieldContext(),
        isLabelHovered = _useFieldContext.isLabelHovered;

    var hiddenInputRef = Object(external_react_["useRef"])(null);
    var triggerRef = Object(external_react_["useRef"])(null);
    var previousIsOpenRef = Object(external_react_["useRef"])(undefined);
    Object(external_react_["useEffect"])(function () {
      // Focus internal input when Menu is opened
      if (isOpen && !previousIsOpenRef.current) {
        hiddenInputRef.current && hiddenInputRef.current.focus();
      } // Focus trigger when Menu is closed


      if (!isOpen && previousIsOpenRef.current) {
        triggerRef.current && triggerRef.current.focus();
      }

      previousIsOpenRef.current = isOpen;
    }, [isOpen]);
    var selectProps = getToggleButtonProps(Select_objectSpread({
      tabIndex: props.disabled ? -1 : 0
    }, props));
    return external_react_default.a.createElement(external_react_popper_["Reference"], null, function (_ref2) {
      var popperReference = _ref2.ref;
      return external_react_default.a.createElement(field_StyledSelect, Select_extends({
        hovered: isLabelHovered && !isOpen,
        focused: isOpen ? isOpen : undefined,
        open: isOpen
      }, selectProps, {
        innerRef: function innerRef(selectRef) {
          // Pass ref to popperJS for positioning
          popperReference(selectRef); // Store ref locally to return focus on close

          triggerRef.current = selectRef; // Apply Select ref to global Dropdown context

          popperReferenceElementRef.current = selectRef;
        }
      }), children, external_react_default.a.createElement(field_StyledInput, getInputProps({
        readOnly: true,
        isHidden: true,
        tabIndex: -1,
        innerRef: hiddenInputRef,
        value: ''
      })));
    });
  };

  Select_Select.propTypes = {
    children: external_prop_types_default.a.node,

    /** Allows flush spacing of Tab elements */
    tagLayout: external_prop_types_default.a.bool,

    /** Applies flex layout to support MediaFigure components */
    mediaLayout: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool,

    /** Removes all borders and styling */
    bare: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,

    /** Applies inset `box-shadow` styling on focus */
    focusInset: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,

    /** Displays select open state */
    open: external_prop_types_default.a.bool,
    validation: external_prop_types_default.a.oneOf([Select_VALIDATION.SUCCESS, Select_VALIDATION.WARNING, Select_VALIDATION.ERROR])
  };
  /* harmony default export */

  var src_Select_Select = Select_Select; // CONCATENATED MODULE: ./src/Fields/Hint.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `div` props. Must be nested with a `<Field>` component.
   */

  var Hint = field_StyledHint;
  Hint.displayName = 'Hint';
  Hint.propTypes = {
    small: external_prop_types_default.a.bool
  };
  /* harmony default export */

  var Fields_Hint = Hint; // CONCATENATED MODULE: ./src/Fields/Label.js

  function Label_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Label_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Label_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function Label_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Label_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Label_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /* eslint-disable react/prop-types */

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<label>` props. Must be nested with a `<Field>` component.
   */


  function Label(_ref) {
    var onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        other = Label_objectWithoutProperties(_ref, ["onMouseEnter", "onMouseLeave"]);

    var _useDropdownContext = utils_useDropdownContext(),
        getLabelProps = _useDropdownContext.downshift.getLabelProps;

    var _useFieldContext = utils_useFieldContext(),
        setIsLabelHovered = _useFieldContext.setIsLabelHovered;

    var labelProps = getLabelProps(Label_objectSpread({
      onMouseEnter: Object(container_selection_["composeEventHandlers"])(onMouseEnter, function () {
        setIsLabelHovered(true);
      }),
      onMouseLeave: Object(container_selection_["composeEventHandlers"])(onMouseLeave, function () {
        setIsLabelHovered(false);
      })
    }, other));
    return external_react_default.a.createElement(field_StyledLabel, labelProps);
  }

  Label.propTypes = {
    regular: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool
  };
  /* harmony default export */

  var Fields_Label = Label; // CONCATENATED MODULE: ./src/Fields/Message.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var Message_VALIDATION = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    NONE: 'none'
  };
  /**
   * Accepts all `<div>` props. Must be nested with a `<Field>` component.
   */

  var Message = field_StyledMessage;
  Message.displayName = 'Message';
  Message.propTypes = {
    validation: external_prop_types_default.a.oneOf([Message_VALIDATION.SUCCESS, Message_VALIDATION.WARNING, Message_VALIDATION.ERROR, Message_VALIDATION.NONE])
  };
  /* harmony default export */

  var Fields_Message = Message; // CONCATENATED MODULE: ./src/utils/garden-placements.js

  function garden_placements_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        garden_placements_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function garden_placements_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var SHARED_PLACEMENTS = {
    AUTO: 'auto',
    TOP: 'top',
    TOP_START: 'top-start',
    TOP_END: 'top-end',
    BOTTOM: 'bottom',
    BOTTOM_START: 'bottom-start',
    BOTTOM_END: 'bottom-end'
  };
  var GARDEN_PLACEMENTS = garden_placements_objectSpread({}, SHARED_PLACEMENTS, {
    END: 'end',
    END_TOP: 'end-top',
    END_BOTTOM: 'end-bottom',
    START: 'start',
    START_TOP: 'start-top',
    START_BOTTOM: 'start-bottom'
  });
  var POPPER_PLACEMENTS = garden_placements_objectSpread({}, SHARED_PLACEMENTS, {
    RIGHT: 'right',
    RIGHT_START: 'right-start',
    RIGHT_END: 'right-end',
    LEFT: 'left',
    LEFT_START: 'left-start',
    LEFT_END: 'left-end'
  });
  /**
   * Convert Garden RTL aware placement to Popper.JS valid placement
   * @param {String} gardenPlacement
   */

  function getPopperPlacement(gardenPlacement) {
    var _objectSpread2;

    var sharedPlacements = {};

    for (var KEY in SHARED_PLACEMENTS) {
      if (Object.prototype.hasOwnProperty.call(SHARED_PLACEMENTS, KEY)) {
        var value = SHARED_PLACEMENTS[KEY];
        sharedPlacements[value] = value;
      }
    }

    var GARDEN_POPPER_MAPPINGS = garden_placements_objectSpread({}, sharedPlacements, (_objectSpread2 = {}, garden_placements_defineProperty(_objectSpread2, GARDEN_PLACEMENTS.END, POPPER_PLACEMENTS.RIGHT), garden_placements_defineProperty(_objectSpread2, GARDEN_PLACEMENTS.END_TOP, POPPER_PLACEMENTS.RIGHT_START), garden_placements_defineProperty(_objectSpread2, GARDEN_PLACEMENTS.END_BOTTOM, POPPER_PLACEMENTS.RIGHT_END), garden_placements_defineProperty(_objectSpread2, GARDEN_PLACEMENTS.START, POPPER_PLACEMENTS.LEFT), garden_placements_defineProperty(_objectSpread2, GARDEN_PLACEMENTS.START_TOP, POPPER_PLACEMENTS.LEFT_START), garden_placements_defineProperty(_objectSpread2, GARDEN_PLACEMENTS.START_BOTTOM, POPPER_PLACEMENTS.LEFT_END), _objectSpread2));
    return GARDEN_POPPER_MAPPINGS[gardenPlacement];
  }
  /**
   * Convert Garden RTL aware placement to RTL equivalent Popper.JS placement
   * @param {String} gardenPlacement
   */


  function getRtlPopperPlacement(gardenPlacement) {
    var _RTL_PLACEMENT_MAPPIN;

    var RTL_PLACEMENT_MAPPINGS = (_RTL_PLACEMENT_MAPPIN = {}, garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT, POPPER_PLACEMENTS.RIGHT), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT_START, POPPER_PLACEMENTS.RIGHT_START), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT_END, POPPER_PLACEMENTS.RIGHT_END), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.TOP_START, POPPER_PLACEMENTS.TOP_END), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.TOP_END, POPPER_PLACEMENTS.TOP_START), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT, POPPER_PLACEMENTS.LEFT), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT_START, POPPER_PLACEMENTS.LEFT_START), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT_END, POPPER_PLACEMENTS.LEFT_END), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.BOTTOM_START, POPPER_PLACEMENTS.BOTTOM_END), garden_placements_defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.BOTTOM_END, POPPER_PLACEMENTS.BOTTOM_START), _RTL_PLACEMENT_MAPPIN);
    var popperPlacement = getPopperPlacement(gardenPlacement);
    return RTL_PLACEMENT_MAPPINGS[popperPlacement] || popperPlacement;
  } // CONCATENATED MODULE: ./src/Menu/Menu.js


  function Menu_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Menu_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Menu_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function Menu_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Menu_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Menu_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var MenuContext = Object(external_react_["createContext"])();
  /**
   * Accepts all `<ul>` props
   */

  var Menu_Menu = function Menu(props) {
    var placement = props.placement,
        popperModifiers = props.popperModifiers,
        eventsEnabled = props.eventsEnabled,
        animate = props.animate,
        maxHeight = props.maxHeight,
        menuStyle = props.style,
        zIndex = props.zIndex,
        otherProps = Menu_objectWithoutProperties(props, ["placement", "popperModifiers", "eventsEnabled", "animate", "maxHeight", "style", "zIndex"]);

    var _useDropdownContext = utils_useDropdownContext(),
        itemIndexRef = _useDropdownContext.itemIndexRef,
        previousIndexRef = _useDropdownContext.previousIndexRef,
        nextItemsHashRef = _useDropdownContext.nextItemsHashRef,
        popperReferenceElementRef = _useDropdownContext.popperReferenceElementRef,
        _useDropdownContext$d = _useDropdownContext.downshift,
        isOpen = _useDropdownContext$d.isOpen,
        getMenuProps = _useDropdownContext$d.getMenuProps;

    var scheduleUpdateRef = Object(external_react_["useRef"])(undefined);
    Object(external_react_["useEffect"])(function () {
      /**
       * Recalculate popper placement while open to allow animations to complete.
       * This must be ran every render to allow for the number of items to change
       * and still be placed correctly.
       **/
      if (isOpen) {
        scheduleUpdateRef.current && scheduleUpdateRef.current();
      }
    }); // Reset Downshift refs on every render

    itemIndexRef.current = 0;
    nextItemsHashRef.current = {};
    previousIndexRef.current = undefined;
    var popperPlacement = Object(react_theming_["isRtl"])(props) ? getRtlPopperPlacement(placement) : getPopperPlacement(placement);
    return external_react_default.a.createElement(MenuContext.Provider, {
      value: {
        itemIndexRef: itemIndexRef
      }
    }, external_react_default.a.createElement(external_react_popper_["Popper"], {
      placement: popperPlacement,
      modifiers: popperModifiers // Disable position updating on scroll events while menu is closed
      ,
      eventsEnabled: isOpen && eventsEnabled
    }, function (_ref) {
      var ref = _ref.ref,
          style = _ref.style,
          scheduleUpdate = _ref.scheduleUpdate,
          currentPlacement = _ref.placement;
      var computedStyle = menuStyle;
      scheduleUpdateRef.current = scheduleUpdate; // Calculate custom width if ref is provided from Select or Autocomplete

      if (popperReferenceElementRef.current && popperReferenceElementRef.current.getBoundingClientRect) {
        computedStyle = Menu_objectSpread({}, menuStyle, {
          width: popperReferenceElementRef.current.getBoundingClientRect().width
        });
      }

      var popperStyle = Menu_objectSpread({}, style, {
        zIndex: zIndex
      });

      if (!isOpen) {
        popperStyle = Menu_objectSpread({}, style, {
          zIndex: -1,
          visibility: 'hidden'
        });
      }

      return external_react_default.a.createElement("div", {
        ref: ref,
        style: popperStyle
      }, external_react_default.a.createElement(menu_StyledMenu, getMenuProps(Menu_objectSpread({
        maxHeight: maxHeight,
        placement: currentPlacement,
        animate: isOpen && animate,
        // Triggers animation start when open
        style: computedStyle
      }, otherProps))));
    }));
  };

  Menu_Menu.propTypes = {
    popperModifiers: external_prop_types_default.a.object,
    eventsEnabled: external_prop_types_default.a.bool,
    zIndex: external_prop_types_default.a.number,
    style: external_prop_types_default.a.object,

    /**
     * These placements differ from the default naming of Popper.JS placements to help
     * assist with RTL layouts.
     **/
    placement: external_prop_types_default.a.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),
    animate: external_prop_types_default.a.bool,
    small: external_prop_types_default.a.bool,
    hidden: external_prop_types_default.a.bool,
    arrow: external_prop_types_default.a.bool,
    maxHeight: external_prop_types_default.a.string,
    children: external_prop_types_default.a.node
  };
  Menu_Menu.defaultProps = {
    placement: 'bottom-start',
    animate: true,
    eventsEnabled: true,
    maxHeight: '400px',
    zIndex: 1000
  };
  /* harmony default export */

  var src_Menu_Menu = Object(react_theming_["withTheme"])(Menu_Menu); // CONCATENATED MODULE: ./src/Menu/Separator.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<li>` props
   */

  var Separator = menu_StyledSeparator;
  Separator.displayName = 'Separator';
  /** @component */

  /* harmony default export */

  var Menu_Separator = Separator; // CONCATENATED MODULE: ./src/utils/useMenuContext.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Retrieve Menu component context
   */

  var useMenuContext_useMenuContext = function useMenuContext() {
    var menuContext = Object(external_react_["useContext"])(MenuContext);

    if (!menuContext) {
      throw new Error('This component must be rendered within a `Menu` component.');
    }

    return menuContext;
  };
  /* harmony default export */


  var utils_useMenuContext = useMenuContext_useMenuContext; // CONCATENATED MODULE: ./src/Menu/Items/Item.js

  function Item_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Item_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Item_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function Item_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Item_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Item_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<li>` props
   */


  var Item_Item = function Item(_ref) {
    var value = _ref.value,
        disabled = _ref.disabled,
        _ref$component = _ref.component,
        component = _ref$component === void 0 ? items_StyledItem : _ref$component,
        props = Item_objectWithoutProperties(_ref, ["value", "disabled", "component"]);

    var _useDropdownContext = utils_useDropdownContext(),
        selectedItems = _useDropdownContext.selectedItems,
        _useDropdownContext$d = _useDropdownContext.downshift,
        isOpen = _useDropdownContext$d.isOpen,
        selectedItem = _useDropdownContext$d.selectedItem,
        highlightedIndex = _useDropdownContext$d.highlightedIndex,
        getItemProps = _useDropdownContext$d.getItemProps,
        setHighlightedIndex = _useDropdownContext$d.setHighlightedIndex,
        itemToString = _useDropdownContext$d.itemToString;

    var _useMenuContext = utils_useMenuContext(),
        itemIndexRef = _useMenuContext.itemIndexRef;

    if (!value && !disabled) {
      throw new Error('All Item components require a `value` prop');
    }

    var currentIndex = itemIndexRef.current;
    var isFocused = highlightedIndex === currentIndex;
    var isSelected; // Calculate selection if provided value is an `object`

    if (selectedItems) {
      isSelected = selectedItems.some(function (item) {
        return itemToString(item) === itemToString(value);
      });
    } else {
      isSelected = itemToString(selectedItem) === itemToString(value);
    }

    Object(external_react_["useEffect"])(function () {
      // Highlight selected item when Select/Autocomplete is open
      if (isOpen && !disabled && !selectedItems && isSelected) {
        setHighlightedIndex(currentIndex);
      }
    }, [currentIndex, disabled, isOpen, isSelected, selectedItems, setHighlightedIndex]);

    if (disabled) {
      return external_react_default.a.createElement(component, Item_objectSpread({
        disabled: disabled
      }, props));
    } // Only increment current item index if the `Item` is not disabled


    itemIndexRef.current++;
    return external_react_default.a.createElement(component, getItemProps(Item_objectSpread({
      item: value,
      focused: isFocused,
      checked: isSelected
    }, props)));
  };

  Item_Item.propTypes = {
    // The value that is returned through Dropdown during selection
    value: external_prop_types_default.a.any,
    // Used to optionally change the root element that is rendered
    component: external_prop_types_default.a.any,
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool
  };
  /* harmony default export */

  var Items_Item = Item_Item; // CONCATENATED MODULE: ./src/Menu/Items/AddItem.js

  function AddItem_extends() {
    AddItem_extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return AddItem_extends.apply(this, arguments);
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<li>` props
   */


  var AddItem_AddItem = function AddItem(props) {
    return external_react_default.a.createElement(Items_Item, AddItem_extends({
      component: items_StyledAddItem
    }, props));
  };

  AddItem_AddItem.propTypes = {
    value: external_prop_types_default.a.string,
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool
  };
  /* harmony default export */

  var Items_AddItem = AddItem_AddItem; // CONCATENATED MODULE: ./src/Menu/Items/HeaderIcon.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<div>` props
   */

  var HeaderIcon = header_StyledHeaderIcon;
  HeaderIcon.displayName = 'HeaderIcon';
  /** @component */

  /* harmony default export */

  var Items_HeaderIcon = HeaderIcon; // CONCATENATED MODULE: ./src/Menu/Items/HeaderItem.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<li>` props
   */

  var HeaderItem = header_StyledHeaderItem;
  HeaderItem.displayName = 'HeaderItem';
  HeaderItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool,

    /** Applies icon styling */
    containsIcon: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var Items_HeaderItem = HeaderItem; // CONCATENATED MODULE: ./src/Menu/Items/ItemMeta.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<div>` props
   */

  var ItemMeta = items_StyledItemMeta;
  ItemMeta.displayName = 'ItemMeta';
  /** @component */

  /* harmony default export */

  var Items_ItemMeta = ItemMeta; // CONCATENATED MODULE: ./src/Menu/Items/MediaBody.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<div>` props
   */

  var MediaBody = media_StyledMediaBody;
  MediaBody.displayName = 'MediaBody';
  /** @component */

  /* harmony default export */

  var Items_MediaBody = MediaBody; // CONCATENATED MODULE: ./src/Menu/Items/MediaFigure.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<div>` props
   */

  var MediaFigure = media_StyledMediaFigure;
  MediaFigure.displayName = 'MediaFigure';
  /** @component */

  /* harmony default export */

  var Items_MediaFigure = MediaFigure; // CONCATENATED MODULE: ./src/Menu/Items/MediaItem.js

  function MediaItem_extends() {
    MediaItem_extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return MediaItem_extends.apply(this, arguments);
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<li>` props
   */


  var MediaItem_MediaItem = function MediaItem(props) {
    return external_react_default.a.createElement(Items_Item, MediaItem_extends({
      component: media_StyledMediaItem
    }, props));
  };

  MediaItem_MediaItem.propTypes = {
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    checked: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var Items_MediaItem = MediaItem_MediaItem; // CONCATENATED MODULE: ./src/Menu/Items/NextItem.js

  function NextItem_extends() {
    NextItem_extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return NextItem_extends.apply(this, arguments);
  }

  function NextItem_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = NextItem_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function NextItem_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<li>` props
   */


  var NextItem_NextItem = function NextItem(_ref) {
    var value = _ref.value,
        disabled = _ref.disabled,
        props = NextItem_objectWithoutProperties(_ref, ["value", "disabled"]);

    var _useDropdownContext = utils_useDropdownContext(),
        nextItemsHashRef = _useDropdownContext.nextItemsHashRef;

    var _useMenuContext = utils_useMenuContext(),
        itemIndexRef = _useMenuContext.itemIndexRef;

    if (disabled) {
      return external_react_default.a.createElement(Items_Item, NextItem_extends({
        component: items_StyledNextItem,
        disabled: true
      }, props));
    } // Include current index in global Dropdown context


    nextItemsHashRef.current[value] = itemIndexRef.current;
    return external_react_default.a.createElement(Items_Item, NextItem_extends({
      component: items_StyledNextItem,
      "aria-expanded": true,
      value: value
    }, props));
  };

  NextItem_NextItem.propTypes = {
    value: external_prop_types_default.a.string,
    disabled: external_prop_types_default.a.bool,
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool
  };
  /* harmony default export */

  var Items_NextItem = NextItem_NextItem; // CONCATENATED MODULE: ./src/Menu/Items/PreviousItem.js

  function PreviousItem_extends() {
    PreviousItem_extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return PreviousItem_extends.apply(this, arguments);
  }

  function PreviousItem_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = PreviousItem_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function PreviousItem_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * Accepts all `<li>` props
   */


  var PreviousItem_PreviousItem = function PreviousItem(_ref) {
    var value = _ref.value,
        disabled = _ref.disabled,
        props = PreviousItem_objectWithoutProperties(_ref, ["value", "disabled"]);

    var _useDropdownContext = utils_useDropdownContext(),
        previousIndexRef = _useDropdownContext.previousIndexRef;

    var _useMenuContext = utils_useMenuContext(),
        itemIndexRef = _useMenuContext.itemIndexRef;

    if (disabled) {
      return external_react_default.a.createElement(Items_Item, PreviousItem_extends({
        component: items_StyledPreviousItem,
        disabled: true
      }, props));
    }

    previousIndexRef.current = itemIndexRef.current;
    return external_react_default.a.createElement(Items_Item, PreviousItem_extends({
      component: items_StyledPreviousItem,
      "aria-expanded": true,
      value: value
    }, props));
  };

  PreviousItem_PreviousItem.propTypes = {
    value: external_prop_types_default.a.any,
    disabled: external_prop_types_default.a.bool,
    active: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    hovered: external_prop_types_default.a.bool
  };
  /* harmony default export */

  var Items_PreviousItem = PreviousItem_PreviousItem; // CONCATENATED MODULE: ./src/index.js

  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "styled", function () {
    return styled;
  });
  /* concated harmony reexport Dropdown */


  __webpack_require__.d(__webpack_exports__, "Dropdown", function () {
    return Dropdown_Dropdown;
  });
  /* concated harmony reexport Trigger */


  __webpack_require__.d(__webpack_exports__, "Trigger", function () {
    return src_Trigger_Trigger;
  });
  /* concated harmony reexport Autocomplete */


  __webpack_require__.d(__webpack_exports__, "Autocomplete", function () {
    return src_Autocomplete_Autocomplete;
  });
  /* concated harmony reexport Select */


  __webpack_require__.d(__webpack_exports__, "Select", function () {
    return src_Select_Select;
  });
  /* concated harmony reexport Field */


  __webpack_require__.d(__webpack_exports__, "Field", function () {
    return Fields_Field;
  });
  /* concated harmony reexport Hint */


  __webpack_require__.d(__webpack_exports__, "Hint", function () {
    return Fields_Hint;
  });
  /* concated harmony reexport Label */


  __webpack_require__.d(__webpack_exports__, "Label", function () {
    return Fields_Label;
  });
  /* concated harmony reexport Message */


  __webpack_require__.d(__webpack_exports__, "Message", function () {
    return Fields_Message;
  });
  /* concated harmony reexport Menu */


  __webpack_require__.d(__webpack_exports__, "Menu", function () {
    return src_Menu_Menu;
  });
  /* concated harmony reexport Separator */


  __webpack_require__.d(__webpack_exports__, "Separator", function () {
    return Menu_Separator;
  });
  /* concated harmony reexport AddItem */


  __webpack_require__.d(__webpack_exports__, "AddItem", function () {
    return Items_AddItem;
  });
  /* concated harmony reexport HeaderIcon */


  __webpack_require__.d(__webpack_exports__, "HeaderIcon", function () {
    return Items_HeaderIcon;
  });
  /* concated harmony reexport HeaderItem */


  __webpack_require__.d(__webpack_exports__, "HeaderItem", function () {
    return Items_HeaderItem;
  });
  /* concated harmony reexport Item */


  __webpack_require__.d(__webpack_exports__, "Item", function () {
    return Items_Item;
  });
  /* concated harmony reexport ItemMeta */


  __webpack_require__.d(__webpack_exports__, "ItemMeta", function () {
    return Items_ItemMeta;
  });
  /* concated harmony reexport MediaBody */


  __webpack_require__.d(__webpack_exports__, "MediaBody", function () {
    return Items_MediaBody;
  });
  /* concated harmony reexport MediaFigure */


  __webpack_require__.d(__webpack_exports__, "MediaFigure", function () {
    return Items_MediaFigure;
  });
  /* concated harmony reexport MediaItem */


  __webpack_require__.d(__webpack_exports__, "MediaItem", function () {
    return Items_MediaItem;
  });
  /* concated harmony reexport NextItem */


  __webpack_require__.d(__webpack_exports__, "NextItem", function () {
    return Items_NextItem;
  });
  /* concated harmony reexport PreviousItem */


  __webpack_require__.d(__webpack_exports__, "PreviousItem", function () {
    return Items_PreviousItem;
  });
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var styled = {
    StyledMenu: menu_StyledMenu,
    StyledSeparator: menu_StyledSeparator,
    StyledAddItem: items_StyledAddItem,
    StyledItem: items_StyledItem,
    StyledItemMeta: items_StyledItemMeta,
    StyledNextItem: items_StyledNextItem,
    StyledPreviousItem: items_StyledPreviousItem,
    StyledHeaderIcon: header_StyledHeaderIcon,
    StyledHeaderItem: header_StyledHeaderItem,
    StyledMediaBody: media_StyledMediaBody,
    StyledMediaFigure: media_StyledMediaFigure,
    StyledMediaItem: media_StyledMediaItem,
    StyledField: field_StyledField,
    StyledLabel: field_StyledLabel,
    StyledHint: field_StyledHint,
    StyledMessage: field_StyledMessage,
    StyledSelect: field_StyledSelect
  };
  /***/
}
/******/
]));